import { render, staticRenderFns } from "./addSingle.vue?vue&type=template&id=aae44322&"
import script from "./addSingle.vue?vue&type=script&lang=js&"
export * from "./addSingle.vue?vue&type=script&lang=js&"
import style0 from "./addSingle.vue?vue&type=style&index=0&id=aae44322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports